<template>
	<div class="routepanel" :class="{ 'routepanel--active': listActive }">
		<div class="routepanel__item" :class="{ 'routepanel__item--active': listActive }">
			<app-routelist
				:config="config"
				:favourites="favourites"
				:registrations="registrations"
				:routes="routes"
				:current-user="currentUser"
				@mouseover="$emit('mouseover', $event)"
				@mouseout="$emit('mouseout', $event)"
				@toggle-favourite="$emit('toggle-favourite', $event)"
			></app-routelist>
		</div>
	</div>
</template>

<script>
	import Routelist from './Routelist.vue';

	export default {
		data() {
			return {
				listActive: false,
				route: {}
			}
		},
		props: {
			config: Object,
			favourites: Object,
			registrations: Object,
			routes: { type: Array, default: () => [] },
			currentUser: { type: [Number, Boolean], default: false }
		},
		emits: ['mouseover', 'mouseout', 'toggle-favourite'],
		components: {
			'app-routelist': Routelist,
		},
		methods: {
			showRouteList(routes) {
				this.listActive = true;
			},
			hideRouteList() {
				this.listActive = false;	
			}
		}
	}
</script>

<style>

</style>